import { Box } from '@mantine/core';

import { SendingIndicator } from '../';
import classes from './SyncingIndicator.module.css';

interface SyncingIndicatorProps {
  isContrast?: boolean;
}

export const SyncingIndicator: React.FC<SyncingIndicatorProps> = ({ isContrast }) => {
  return (
    <Box className={classes.syncingIndicator}>
      <SendingIndicator isContrast={isContrast} inSyncMode />
      <SendingIndicator isContrast={isContrast} inSyncMode />
    </Box>
  );
};
